import React, { FC, useRef } from 'react';
import { MoreActions } from 'components/atoms/delete-in-more-actions';
import { ProjectTemplateTask } from 'data/templates/projects';

export const MoreActionsCell: FC<{
  record: Partial<ProjectTemplateTask>;
  onDelete(record: Partial<ProjectTemplateTask>): void;
}> = ({ record, onDelete }) => {
  const cellRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={cellRef}>
      <MoreActions
        attachTo={cellRef.current as HTMLElement}
        data={record}
        onDelete={(_record) => onDelete(_record)}
        disabledAction={!record?.taskId}
      />
    </div>
  );
};
